import React from 'react'
import { Helmet } from 'react-helmet'
import { useDevTools } from 'global/context/sub-contexts/devToolsContext'

// A break with no themeColor3/4 must not publish the literal `undefined`: an unset custom
// property lets a consumer's var(--x, fallback) apply, an `undefined` one silently voids it.
const cssVar = (name, value) => (value ? `${name}: ${value};` : '')

// The selected-answer circle follows the button colour. Its default, var(--theme-color-primary),
// resolves on <body>, where it is still Dailybreak purple, so it has to be set here on main.
const buildInlineStyle = brk => `
body main.sponsored {
  background-color: ${brk.themeColor1};
  color: ${brk.themeColor2};

  --text-color-primary: ${brk.themeColor2};
  ${cssVar('--theme-color-button', brk.themeColor3)}
  ${cssVar('--button-text-color-primary', brk.themeColor4)}
  ${cssVar('--quiz-answer-check-background', brk.themeColor3)}
}

main.sponsored .themed-button,
main.sponsored .themed-button:hover {
    background-color : ${brk.themeColor3};
    color : ${brk.themeColor4};
    border-color : ${brk.themeColor3};
}

main.sponsored .themed-button-secondary {
  background-color : transparent;
  color : ${brk.themeColor4};
  border : 2px solid ${brk.themeColor3};
}

.sponsored .themed-secondary {
  background-color : ${brk.themeColor5 ? brk.themeColor5 : '#EEEAF4'};
  color : ${brk.themeColor6 ? brk.themeColor6 : '#646464'};
}
`

export const BreakThemeProvider = ({ brk, isEmbed, inline = false }) => {
  const { customCssDisabled } = useDevTools()
  return (
    <>
      <Helmet
        bodyAttributes={{
          // `is-embed` styles the break as a standalone page with no site
          // chrome: the step nav is pinned to the viewport top. Rendered inline
          // inside a page that has its own header, that nav covers the header,
          // so an inline break takes the `no-embed` layout regardless of
          // `isEmbed`, which only governs the guest auth flow.
          class: `sponsored ${
            isEmbed && !inline ? 'is-embed' : 'no-embed'
          } ${brk.permalink}`,
        }}
      />
      {brk.customCss && !customCssDisabled && (
        <style dangerouslySetInnerHTML={{ __html: brk.customCss }} />
      )}
      <style dangerouslySetInnerHTML={{ __html: buildInlineStyle(brk) }} />
    </>
  )
}
